import { render, staticRenderFns } from "./printLicenseDetalsSection.vue?vue&type=template&id=2281f856&scoped=true&"
import script from "./printLicenseDetalsSection.vue?vue&type=script&lang=tsx&"
export * from "./printLicenseDetalsSection.vue?vue&type=script&lang=tsx&"
import style0 from "./printLicenseDetalsSection.vue?vue&type=style&index=0&id=2281f856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2281f856",
  null
  
)

export default component.exports